import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { requestReadMessage, closeOpenedMessage, requestDeleteMessages } from "../../store/actionCreators/messages";
import {useDispatch} from "react-redux";
import { useSelector } from 'react-redux';
import { getOpenedMessage, getCurrentAccountId } from "../../store/selectors";
import '../../assets/stylesheets/Messages/MessagesPage.scss';
import { faChevronLeft, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Link, useParams, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Message = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    const message = useSelector(getOpenedMessage);
    const accountId = useSelector(getCurrentAccountId);
    const { param1, param2, text } = message.content;
    const { id: clubId } = useParams();

    const close = () => {
        if (message.status !== 'read') {
            dispatch(requestReadMessage({ messageId: message._id, accountId }));
        }
        dispatch(closeOpenedMessage());
        history.push(!!clubId ? `/club/${clubId}` : '/');
    };

    const deleteMessage = () => {
        dispatch(requestDeleteMessages([message._id]));
    };

    const getCloseLink = () => {
        return clubId ? `/club/${clubId}/messages` : `/messages`; 
    };

    return (
        <React.Fragment>
            {!!message &&
                <div className={`message`}>
                    <div className={`header`}>
                        <span onClick={close} className={`arrow`}>
                            <Link to={getCloseLink()}>
                                <FontAwesomeIcon icon={faChevronLeft} color="white" className="fa chevron-left"></FontAwesomeIcon>
                            </Link>
                        </span>
                        <span>{t('footer.items.messages')}</span>
                        <span onClick={close} className={`close`}>
                            <FontAwesomeIcon icon={faTimes} color="white" className="fa fa-times"></FontAwesomeIcon>
                        </span>
                    </div>
                    <div className="msg-container">
                        <div className={`header`}>
                            <span className={`title`}>{t(message.header)}</span>
                            <span className="date">{moment(message.dateCreated).format('LL')}</span>
                        </div>
                        <div className={`content`}>{t(text, { messageParam1: param1 || null, messageParam2: param2 || null })}</div>
                        {/* need to check translation */}
                        <div className={`delete`}>
                            <div className={'info'}>{t('messages.deleteMessageInfo')}</div>
                            <div onClick={deleteMessage} className={'action'}>{t('messages.deleteMessages')}</div>
                        </div>
                    </div>
                </div>
            }
        </React.Fragment>
    );
};

export default Message;